import { Adapter } from 'component-registry'
import { ListItem } from './LiveListItem'
import { IListItem } from '../../../interfaces/presentation'
import { IMediaCard } from 'influence-app-entities/lib/interfaces/cards/MediaCard'

new Adapter({
  implements: IListItem,
  adapts: IMediaCard,
  Component: ListItem
})